(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-banner"] && !Shopify.designMode) return;
  try {
    
  const swiperEl = document.querySelector('.swiper-banners');
  if (swiperEl) {
    const swiper = new Swiper('.swiper-banners', {
      slidesPerView: 1,
      spaceBetween: 12,
      centeredSlides: true,
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        600: {
          slidesPerView: 3,
          spaceBetween: 16,
          centeredSlides: true,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 20,
          centeredSlides: false,
        },
      },
    });
  }

  } catch(e) { console.error(e); }
})();
})();
